import React, { FC } from 'react'

import { IconConnectivityProps } from './IconConnectivity.types'
import * as Styled from './styles/IconConnectivity.style'

import { nonThemeableRules } from '../../ruleSet'

const IconConnectivity: FC<IconConnectivityProps> = ({
  size = nonThemeableRules.defaultSize as number as IconConnectivityProps['size'],
  isResponsive = false,
}: IconConnectivityProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M36.085 9.337a19 19 0 1 1-24.167 29.326A19 19 0 0 1 36.085 9.337'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M30.325 15.75a25.5 25.5 0 0 1 3.125 3.4 25.852 25.852 0 0 1 5.225 16.9M12.395 8.955a27.486 27.486 0 0 1 14.023 3.887m-4.95 23.518A26.616 26.616 0 0 0 23.555 43m3.225-26.975A25.315 25.315 0 0 0 21.095 31.5M35.6 8.952a28.091 28.091 0 0 0-5.408 3.595m.671 1.573c3.568-.003 7.104.67 10.422 1.982M13.768 20.6a25.81 25.81 0 0 1 12.25-6.015M6.472 31.345a27.124 27.124 0 0 1 3.968-7.188m12.75 11.146a27.236 27.236 0 0 0 12.385 3.75M13.03 24.5a26.815 26.815 0 0 0 6.22 7.94M9.82 11.355A29.973 29.973 0 0 0 11.177 20'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M12.015 24.733a2.438 2.438 0 1 0 0-4.876 2.438 2.438 0 0 0 0 4.876Zm9.148 11.647a2.437 2.437 0 1 0 0-4.875 2.437 2.437 0 0 0 0 4.875Zm7.262-19.717a2.437 2.437 0 1 0 0-4.875 2.437 2.437 0 0 0 0 4.875Z'
          stroke='#E60000'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconConnectivity
